import { render, staticRenderFns } from "./userHeader.vue?vue&type=template&id=2213e9a0"
import script from "./userHeader.vue?vue&type=script&lang=js"
export * from "./userHeader.vue?vue&type=script&lang=js"
import style0 from "./userHeader.vue?vue&type=style&index=0&id=2213e9a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports